'use client';

import { Box, ButtonBase, SvgIcon, type SxProps } from '@mui/material';
import { flatSx } from '@ocodelib/mui';
import OcodeLogoIcon from '@repo-foundation/icons/OcodeLogoIcon';
import clsx from 'clsx';
import { LinkI18n } from '../i18n/routing';

interface Props {
  sx?: SxProps;
  className?: string;
  href: string;
  title: string;
}

export function LogoLinkButton(props: Props) {
  const { sx, className, href, title } = props;

  return (
    <ButtonBase
      className={clsx('LogoLinkButton-root', className)}
      disableRipple
      LinkComponent={LinkI18n}
      href={href}
      sx={flatSx(
        {
          height: '100%',
          pl: 1,
          pr: 2,
          color: 'primary.contrastText',
          '&:hover': {
            opacity: 0.5,
          },
        },
        sx,
      )}
    >
      {/* <Image src="/_static/images/ocode_logo_sub.png" width={36} height={36} alt="logo" />
      <Image src="/_static/images/logo_icon.svg" width={36} height={36} alt="logo" /> */}
      <SvgIcon
        component={OcodeLogoIcon}
        inheritViewBox
        sx={{
          color: 'primary.contrastText',
          width: 36,
          height: 36,
        }}
      />
      <Box
        sx={{
          fontSize: '1.2rem',
          ml: 1,
          lineHeight: 1.2,
        }}
      >
        {title}
      </Box>
    </ButtonBase>
  );
}
